export enum Period {
  Weekly = "weekly",
  Monthly = "monthly",
  Quarterly = "quarterly",
}
